import z from "zod";
export const tables = [
  "categories",
  "datasets",
  "partners",
  "recruitment_applications",
  "recruitment_candidates",
  "recruitment_clients",
  "recruitment_jobs",
  "contacts",
  "recruitment_jobs_categories",
  "users",
  "user_datasets",
] as const;
export type filtersNames =
  "recruitment_jobs" | "recruitment_clients" | "recruitment_candidates" | "recruitment_applications" | "contacts";
export type DataFiltersType = Record<filtersNames, Record<string, FilterType>>;
export type FilterType = {
  textInput?: { active: boolean; value: string };
  multiSelect?: { label: string; active: boolean; options: FilterOptionsType };
  foreignKey?: {
    active: boolean;
    table: (typeof tables)[number];
    column: string;
    label: string;
    columnLabel: string;
    options: FilterOptionsType;
  };
  dateRange?: { label: string; active: boolean; from: string; to: string };
  numericRange?: { label: string; active: boolean; min?: number; max?: number };
};

export type FilterOptionsType = { label: string; value: string; selected: boolean }[] | [];

export const recruitmentJobsFilters = {
  client_id: {
    textInput: { active: false, value: "" },
    foreignKey: {
      active: true,
      table: "recruitment_clients",
      column: "id",
      label: "name",
      columnLabel: "Client",
      options: [],
    },
  },
  recruitment_clients: {
    name: {
      textInput: { active: true, value: "" },
      multiSelect: { label: "Name", active: false, options: [] },
    },
    industry: {
      textInput: { active: true, value: "" },
      multiSelect: { label: "Industry", active: true, options: [] },
    },
    notes: {
      textInput: { active: true, value: "" },
      multiSelect: { label: "Notes", active: false, options: [] },
    },
  },
  code: {
    textInput: { active: true, value: "" },
  },
  description: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Description", active: false, options: [] },
  },
  title: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Title", active: false, options: [] },
  },
  location: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Location", active: false, options: [] },
  },
  salary: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Salary", active: false, options: [] },
  },
  requirements: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Requirements", active: false, options: [] },
  },
  status: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Status", active: true, options: [] },
  },
  "recruitment_jobs.owner": {
    multiSelect: { label: "Owner", active: true, options: [] },
  },
  "recruitment_jobs.created_by": {
    multiSelect: { label: "Created By", active: true, options: [] },
  },
  "recruitment_jobs.created_at": {
    dateRange: { label: "Created At", active: true, from: "", to: "" },
  },
  "recruitment_jobs.updated_at": {
    dateRange: { label: "Updated At", active: true, from: "", to: "" },
  },
};

export const recruitmentClientsFilters = {
  "recruitment_clients.remote_id": {
    textInput: { active: true, value: "" },
  },
  name: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Name", active: false, options: [] },
  },
  industry: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Industry", active: false, options: [] },
  },
  status: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Status", active: true, options: [] },
  },
  // notes: {
  //   textInput: { active: true, value: "" },
  //   multiSelect: { label: "Notes", active: false, options: [] },
  // },
  // contacts: {
  //   multiSelect: { label: "Contacts", active: true, options: [] },
  // },
  "recruitment_clients.created_at": {
    dateRange: { label: "Created At", active: true, from: "", to: "" },
  },
  "recruitment_clients.updated_at": {
    dateRange: { label: "Updated At", active: true, from: "", to: "" },
  },
  // "recruitment_clients.owners": {
  //   multiSelect: { label: "Owners", active: true, options: [] },
  // },
};

export const recruitmentCandidatesFilters = {
  status: {
    multiSelect: { label: "Status", active: false, options: [] },
  },
  skills: {
    multiSelect: { label: "Skills", active: false, options: [] },
  },
  "recruitment_candidates.remote_id": {
    textInput: { active: true, value: "" },
  },
  "recruitment_candidates.created_at": {
    dateRange: { label: "Created At", active: true, from: "", to: "" },
  },
  "recruitment_candidates.updated_at": {
    dateRange: { label: "Updated At", active: true, from: "", to: "" },
  },
  "recruitment_candidates.owner": {
    multiSelect: { label: "Owner", active: true, options: [] },
  },
};

export const recruitmentApplicationsFilters = {
  "recruitment_applications.email": {
    textInput: { active: true, value: "" },
  },
  phone_number: {
    textInput: { active: true, value: "" },
  },
  stage: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Stage", active: false, options: [] },
  },
  "recruitment_applications.first_name": {
    textInput: { active: true, value: "" },
  },
  "recruitment_jobs.title": {
    textInput: { active: true, value: "" },
  },
  "recruitment_applications.created_at": {
    dateRange: { label: "Created At", active: true, from: "", to: "" },
  },
  "recruitment_applications.updated_at": {
    dateRange: { label: "Updated At", active: true, from: "", to: "" },
  },
  "recruitment_applications.screening_questions": {
    textInput: { active: true, value: "" },
  },
};

export const contactsFilters = {
  "contacts.remote_id": {
    textInput: { active: true, value: "" },
  },
  full_name: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Name", active: false, options: [] },
  },
  occupation: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Occupation", active: false, options: [] },
  },
  status: {
    textInput: { active: true, value: "" },
    multiSelect: { label: "Status", active: true, options: [] },
  },
  emails: {
    textInput: { active: true, value: "" },
  },
  phones: {
    textInput: { active: true, value: "" },
  },
  profile_urls: {
    textInput: { active: true, value: "" },
  },
  "contacts.owner": {
    multiSelect: { label: "Owner", active: true, options: [] },
  },
  "contacts.created_at": {
    dateRange: { label: "Created At", active: true, from: "", to: "" },
  },
  "contacts.updated_at": {
    dateRange: { label: "Updated At", active: true, from: "", to: "" },
  },
};

export const dataFilters = {
  recruitment_jobs: recruitmentJobsFilters,
  recruitment_clients: recruitmentClientsFilters,
  recruitment_candidates: recruitmentCandidatesFilters,
  recruitment_applications: recruitmentApplicationsFilters,
  contacts: contactsFilters,
};

export const SEARCHABLE_ATTRIBUTE_TYPES = ["Text", "Number", "Select", "Multi Select"] as const;

export function isAttributeTypeSearchable(type: string): type is (typeof SEARCHABLE_ATTRIBUTE_TYPES)[number] {
  return SEARCHABLE_ATTRIBUTE_TYPES.includes(type as (typeof SEARCHABLE_ATTRIBUTE_TYPES)[number]);
}

export function normalizeAttributeSearchable<T extends { type: string; searchable?: boolean }>(attribute: T) {
  return {
    ...attribute,
    searchable: isAttributeTypeSearchable(attribute.type) ? !!attribute.searchable : false,
  };
}

export function normalizeAttributesSearchable<T extends { type: string; searchable?: boolean }>(attributes: T[]) {
  return attributes.map((attribute) => normalizeAttributeSearchable(attribute));
}

export const ATTRIBUTE_TYPES = [
  "Text",
  "Number",
  "Checkbox",
  "Date",
  "TimeStamp",
  "Select",
  "Multi Select",
  "Record",
  "Multi Record",
] as const;

export const attrType = z.object({
  id: z.string(),
  name: z.string().min(1),
  description: z.string().optional(),
  searchable: z.boolean().default(false),
  type: z.enum(ATTRIBUTE_TYPES),
  table_reference: z.string().optional(),
  optionsCreatable: z.boolean().optional(),
  options: z.array(z.object({ label: z.string(), value: z.string(), index: z.number() })).optional(),
  defaultValue: z
    .union([z.string(), z.boolean(), z.array(z.object({ label: z.string(), value: z.string() }))])
    .optional(),
  boundaries: z.object({ required: z.boolean(), unique: z.boolean() }),
  richText: z.boolean().optional(),
  dateTimeFormat: z
    .union([z.literal("default"), z.literal("relative"), z.literal("age_in_years"), z.literal("month_year")])
    .optional(),
});

export const attrTypes = z.array(attrType);
export type AttrType = z.infer<typeof attrType>;
export type AttrTypes = z.infer<typeof attrTypes>;

export const attributeValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.array(z.string()),
  z.array(z.record(z.string(), z.any())),
]);
export type AttributeValueSchema = z.infer<typeof attributeValueSchema>;
export const attributesMap = z.record(z.string(), attributeValueSchema);
export type AttributesMap = z.infer<typeof attributesMap>;
